module.exports = __webpack_public_path__ + "static/media/sample_gift_card_banner.37521dbf.jpeg";